import { Reducer } from 'redux'
import { initialModalState } from './initialState'
import { HIDE_MODAL, ModalActionTypes, ModalState, SHOW_MODAL } from './types'

const reducer: Reducer<ModalState, ModalActionTypes> = (state: ModalState = initialModalState, action: ModalActionTypes) => {
	switch (action.type) {
		case SHOW_MODAL: {
			return {
				...state, ...{
					name: action.payload.name,
					context: action.payload.context
				}
			}
		}
		case HIDE_MODAL: {
			return {
				...state, ...{
					name: ''
				}
			}
		}
		default: {
			return state
		}
	}
}

export { reducer as modalReducer }

